import type { Translator } from "../i18n/locales";
import { escapeHtml } from "./templates";

export type SpendFeedback = { phase: "saving" | "sending"; remaining: number };

export function renderSpendFeedback(feedback: SpendFeedback | null, t: Translator): string {
  return `<p class="spend-feedback" data-spend-feedback role="status" ${feedback === null ? "hidden" : ""}>${feedback === null ? "" : escapeHtml(feedback.phase === "saving"
    ? t("spend.savingBody", { count: feedback.remaining }) : t("spend.sendingBody"))}</p>`;
}
